import React from 'react';
import styled from 'styled-components';

const Loader = () => {
    return (
        <StyledWrapper>
            <div className="loader-wrapper">
                <div className="loader" />
                <div className="letter-wrapper">
                    <span className="loader-letter">S</span>
                    <span className="loader-letter">e</span>
                    <span className="loader-letter">a</span>
                    <span className="loader-letter">r</span>
                    <span className="loader-letter">c</span>
                    <span className="loader-letter">h</span>
                    <span className="loader-letter">i</span>
                    <span className="loader-letter">n</span>
                    <span className="loader-letter">g</span>
                </div>
            </div>
        </StyledWrapper>
    );
}

const StyledWrapper = styled.div`
  .loader-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #262626;
    user-select: none;
    gap: 10px;
  }

  .loader {
    width: 20px;
    height: 20px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    background-color: transparent;
    animation: loader-rotate 1.5s linear infinite;
    z-index: 0;
  }

  @keyframes loader-rotate {
    0% {
      transform: rotate(90deg);
      box-shadow:
        0 1px 1px 0 #fff inset,
        0 3px 5px 0 #ff2b2b inset,
        0 4px 4px 0 #ff0606 inset;
    }
    50% {
      transform: rotate(270deg);
      background: #ffe8e9;
      box-shadow:
        0 1px 1px 0 #ffc8c8 inset,
        0 3px 5px 0 #ff1b1b inset,
        0 4px 4px 0 #fbef19 inset;
    }
    100% {
      transform: rotate(450deg);
      box-shadow:
        0 1px 1px 0 #fff inset,
        0 3px 5px 0 #ff8f8f inset,
        0 4px 4px 0 #ff1b1b inset;
    }
  }
  .letter-wrapper {
    display: flex;
    gap: 1px;
  }
  .loader-letter {
    display: inline-block;
    opacity: 0.4;
    transform: translateY(0);
    animation: loader-letter-anim 2s infinite;
    z-index: 1;
    border-radius: 50ch;
    border: none;
  }

  .loader-letter:nth-child(1) {
    animation-delay: 0s;
  }
  .loader-letter:nth-child(2) {
    animation-delay: 0.1s;
  }
  .loader-letter:nth-child(3) {
    animation-delay: 0.2s;
  }
  .loader-letter:nth-child(4) {
    animation-delay: 0.3s;
  }
  .loader-letter:nth-child(5) {
    animation-delay: 0.4s;
  }
  .loader-letter:nth-child(6) {
    animation-delay: 0.5s;
  }
  .loader-letter:nth-child(7) {
    animation-delay: 0.6s;
  }
  .loader-letter:nth-child(8) {
    animation-delay: 0.7s;
  }
  .loader-letter:nth-child(9) {
    animation-delay: 0.8s;
  }
  .loader-letter:nth-child(10) {
    animation-delay: 0.9s;
  }

  @keyframes loader-letter-anim {
    0%,
    100% {
      opacity: 0.4;
      transform: translateY(0);
    }
    20% {
      opacity: 1;
      transform: scale(1.15);
    }
    40% {
      opacity: 0.7;
      transform: translateY(0);
    }
  }`;

export default Loader;
